import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { PATHS } from '@/common';

export interface UploadedFileResponse {
  id?: number;
  s3_url?: string;
}

interface Payload {
  documentId: string;
  hashId?: string;
  objectKey?: string;
  employeeId?: string;
  fileName?: string;
}

const useCompleteFileUploadByLinkQuery = () => {
  const { mutateAsync, isLoading } = useMutation(
    (payload: Payload) => api.post<UploadedFileResponse>(PATHS.COMPLETE_FILE_UPLOAD_BY_LINK(payload.documentId), {
      hash_id: payload?.hashId,
      object_key: payload?.objectKey,
      employee_id: payload?.employeeId,
      file_name: payload?.fileName,
    })
  );

  return {
    completeFileUploadByLink: mutateAsync,
    isLoading,
  };
};

export default useCompleteFileUploadByLinkQuery;
